//import components
import Vue from "vue";
import Cookies from "js-cookie";
import VueTheMask from "vue-the-mask";
import mavonEditor from "mavon-editor";
import VuetifyMoney from "vuetify-money";
import Vuetify from "vuetify";

import { helpers } from "@src/utils/helpers";
import { globals } from "@src/utils/globals";
import { requestStatus } from "./utils/checkRequestStatus";
import { compareObjects } from "./utils/compareObjects";

//import css files
import "vuetify/dist/vuetify.min.css";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import "vue-multiselect/dist/vue-multiselect.min.css";
import "mavon-editor/dist/css/index.css";
// import ECharts modules manually to reduce bundle size
import "echarts/lib/chart/bar";
import "echarts/lib/chart/pie";
import "echarts/lib/chart/gauge";
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/title";
import "echarts/lib/echarts";
import "echarts/lib/scale/Scale";
import "echarts/lib/coord/Axis";
import "echarts/lib/CoordinateSystem";
import "echarts/lib/component/axis";
import "echarts/lib/component/grid";
/**
 * Require all Base components.
 *
 * For more, check out official docs
 *
 * https://vuejs.org/v2/style-guide/#Base-component-names-strongly-recommended
 */
var requireComponent = require.context(
    "./components",
    true,
    /[Base|B2c|B2b][A-Z]\w+\.(vue|js)$/
);
requireComponent.keys().forEach(function (fileName) {
    var baseComponentConfig = requireComponent(fileName);
    baseComponentConfig = baseComponentConfig.default || baseComponentConfig;
    var baseComponentName =
        baseComponentConfig.name ||
        fileName.replace(/^.+\//, "").replace(/\.\w+$/, "");
    Vue.component(baseComponentName, baseComponentConfig);
});

// Global Vue component registrations
Vue.component(
    "vue-phone-number-input",
    require("vue-phone-number-input").default
);
Vue.component(
    "modal-changed-operation-to-shopping-cart-component",
    require("./components/b2b/budget/ModalChangedOperationToShoppingCartComponent.vue")
        .default
);
Vue.component(
    "modal-clutch-kit",
    require("./components/b2b/budget/kitModal/KitModal.vue").default
);
Vue.component(
    "information-modal",
    require("./components/shared/widgets/InformationModal.vue").default
);
Vue.component(
    "datarepair-modal",
    require("./components/b2b/datarepair/DatarepairModal.vue").default
);
Vue.component(
    "webshop-modal",
    require("./components/b2b/webshop/WebshopModal.vue").default
);
Vue.component("v-chart", require("vue-echarts").default);

Vue.config.productionTip = false;

Vue.use(Vuetify);
Vue.use(Cookies);
Vue.use(VueTheMask);
Vue.use(VuetifyMoney);
Vue.use(mavonEditor);

Vue.prototype.$helpers = helpers;
Vue.prototype.$globals = globals;
Vue.prototype.$requestStatus = requestStatus;
Vue.prototype.$compareObjects = compareObjects;
Vue.prototype.$cookies = Cookies;
